<template>
  <div class="mobile-collapse">
    <div
      v-if="isMobileScreen"
      class="mobile-collapse__header"
      @click="open = !open"
    >
      <span>{{ title }}</span>
      <font-awesome-icon :icon="open ? 'chevron-up' : 'chevron-down'" />
    </div>
    <div v-show="!isMobileScreen || open" class="mobile-collapse__body">
      <slot />
    </div>
  </div>
</template>

<script>
  import mixinMobileScreen from '@/mixins/mobile-screen'

  export default {
    name: 'MobileCollapse',
    mixins: [mixinMobileScreen],
    props: {
      title: { type: String, default: 'Фильтры' },
      openByDefault: { type: Boolean, default: false },
    },
    data () {
      return {
        open: this.openByDefault,
      }
    },
  }
</script>

<style lang="less" scoped>
.mobile-collapse__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 44px;
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #f7f8fa;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
}
</style>
